import React, { useEffect, useState } from "react";
import { TextField } from "../../primary";
import commonStyles from "../../../styles/common.module.scss";
import style from "./patientSearch.module.scss";
import searchIcon from "../../../static/images/search-icon.svg";
import { SearchModal } from "./searchModal";

export const PatientSearch = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [lookupPatient, setLookupPatient] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [showClearX, setShowClearX] = useState(false);

  useEffect(() => {
    setShowClearX(!!lookupPatient);
  }, [lookupPatient, setShowClearX]);

  const handlePatientSearch = (e) => {
    e.preventDefault();
    if (e?.keyCode === 13) {
      setSearchOpen(true);
      setSearchKey(e?.target?.value);
      setLookupPatient("");
    }
  };

  return (
    <>
      <TextField
        classes={{
          column: `form-group no-gutters ${commonStyles.form_group} position-relative col-sm-8 p-0 m-2`,
          inputClassName: `form-control mb-1 ${style.pl40} `,
          labelClass: `position-absolute ${style.search_icon_image}`,
        }}
        label={<img src={searchIcon} alt="search icon" />}
        type={"text"}
        name={"searchPatient"}
        id={"searchPatient"}
        placeholder={"Patient Search"}
        onKeyUp={handlePatientSearch}
        value={lookupPatient}
        getSearchValue={() => setLookupPatient("")}
        onChange={(e) => setLookupPatient(e?.target?.value)}
        showClearX={showClearX}
        setShowClearX={setShowClearX}
      />
      {searchOpen && <SearchModal modalOpen={searchOpen} setModalOpen={setSearchOpen} searchKey={searchKey} />}
    </>
  );
};
